module.exports = __webpack_public_path__ + "img/check.cc708aef.svg";